import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, invalid, ...props },
  ref,
) {
  return (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        "min-h-[88px] w-full resize-y rounded-xl border bg-input px-3.5 py-2.5 text-sm text-fg transition-colors",
        "placeholder:text-fg-subtle",
        "focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-ring/45",
        "disabled:cursor-not-allowed disabled:opacity-50",
        invalid ? "border-danger focus-visible:ring-danger/35" : "border-border",
        className,
      )}
      {...props}
    />
  );
});
